import AudioIcon from '@/assets/icons/fileIcons/audio.svg'
import CertificateIcon from '@/assets/icons/fileIcons/certificate.svg'
import CodeIcon from '@/assets/icons/fileIcons/code.svg'
import CompressedIcon from '@/assets/icons/fileIcons/compressed.svg'
import CsvIcon from '@/assets/icons/fileIcons/csv.svg'
import DefaultIcon from '@/assets/icons/fileIcons/default.svg'
import DesignIcon from '@/assets/icons/fileIcons/design.svg'
import DocIcon from '@/assets/icons/fileIcons/doc.svg'
import DocumentIcon from '@/assets/icons/fileIcons/document.svg'
import ExecutableIcon from '@/assets/icons/fileIcons/executable.svg'
import FontIcon from '@/assets/icons/fileIcons/font.svg'
import ImageIcon from '@/assets/icons/fileIcons/image.svg'
import MdIcon from '@/assets/icons/fileIcons/md.svg'
import PdfIcon from '@/assets/icons/fileIcons/pdf.svg'
import PptIcon from '@/assets/icons/fileIcons/ppt.svg'
import VideoIcon from '@/assets/icons/fileIcons/video.svg'
import XlsxIcon from '@/assets/icons/fileIcons/xlsx.svg'
import { cn } from '@/utils/style'

// Extension -> icon type mapping
const extToType: Record<string, string> = {
  // Audio
  mp3: 'audio',
  wav: 'audio',
  flac: 'audio',
  aac: 'audio',
  ogg: 'audio',
  m4a: 'audio',
  // Video
  mp4: 'video',
  mov: 'video',
  avi: 'video',
  mkv: 'video',
  wmv: 'video',
  webm: 'video',
  // Image
  png: 'image',
  jpg: 'image',
  jpeg: 'image',
  gif: 'image',
  svg: 'image',
  webp: 'image',
  bmp: 'image',
  ico: 'image',
  // Code
  ts: 'code',
  tsx: 'code',
  js: 'code',
  jsx: 'code',
  py: 'code',
  go: 'code',
  java: 'code',
  c: 'code',
  cpp: 'code',
  h: 'code',
  rs: 'code',
  rb: 'code',
  php: 'code',
  html: 'code',
  css: 'code',
  scss: 'code',
  json: 'code',
  xml: 'code',
  yaml: 'code',
  yml: 'code',
  sh: 'code',
  // Documents
  pdf: 'pdf',
  doc: 'doc',
  docx: 'doc',
  ppt: 'ppt',
  pptx: 'ppt',
  xls: 'xlsx',
  xlsx: 'xlsx',
  csv: 'csv',
  txt: 'document',
  md: 'md',
  markdown: 'md',
  // Compressed
  zip: 'compressed',
  tar: 'compressed',
  gz: 'compressed',
  rar: 'compressed',
  '7z': 'compressed',
  // Design
  psd: 'design',
  ai: 'design',
  sketch: 'design',
  fig: 'design',
  xd: 'design',
  // Font
  ttf: 'font',
  otf: 'font',
  woff: 'font',
  woff2: 'font',
  // Executable
  exe: 'executable',
  msi: 'executable',
  dmg: 'executable',
  app: 'executable',
  apk: 'executable',
  // Certificate
  crt: 'certificate',
  cer: 'certificate',
  pem: 'certificate',
  key: 'certificate',
}

// Icon type -> Src mapping
const typeToIcon: Record<string, string> = {
  audio: AudioIcon,
  video: VideoIcon,
  image: ImageIcon,
  code: CodeIcon,
  pdf: PdfIcon,
  doc: DocIcon,
  ppt: PptIcon,
  xlsx: XlsxIcon,
  csv: CsvIcon,
  document: DocumentIcon,
  md: MdIcon,
  compressed: CompressedIcon,
  design: DesignIcon,
  font: FontIcon,
  executable: ExecutableIcon,
  certificate: CertificateIcon,
  default: DefaultIcon,
}

interface FileIconProps {
  ext?: string
  className?: string
}

export function FileIcon({ ext, className }: FileIconProps) {
  const type = ext ? extToType[ext.toLowerCase()] || 'default' : 'default'
  const iconSrc = typeToIcon[type]
  return (
    <img src={iconSrc} className={cn('h-5 w-5', className)} alt={ext || 'file'} draggable={false} />
  )
}
